<div class="notification-banner" [ngClass]="{'min': show_min, 'closed': closed}">
  <div [innerText]="nt_production"></div>
  <i class="fa" [ngClass]="i_class" (click)="toggleMinMax()"
     matTooltip="Minimise this notification" [matTooltipDisabled]="show_min"></i>
  <i class="fa fa-times" (click)="close()" matTooltip="Close this notification" ></i>
</div>
